import { ReactNode } from 'react'
import Image from 'next/image'
import cn from 'classnames'
import MasterclassCertificatesLogo from 'pages/certificates/assets/MasterclassCertificates.svg'

interface LogoSectionProps {
  companyLogo?: {
    url: string
    altText?: string
  }
  className?: string
  children?: ReactNode
  alignLogoStart?: boolean
}

export const LogoSection = ({
  companyLogo,
  className,
  children,
  alignLogoStart = false,
}: LogoSectionProps) => (
  <div
    className={cn(
      'flex items-center w-full justify-center lg:justify-start',
      className,
    )}
  >
    {!companyLogo?.url && (
      <MasterclassCertificatesLogo className='mt-4 h-[50px] w-[180px]' />
    )}
    {companyLogo?.url && (
      <Image
        src={companyLogo.url}
        alt={companyLogo.altText || ''}
        width={400}
        height={100}
        sizes='(max-width: 768px) 100vw, 400px'
        className={cn('w-full max-w-[400px] object-contain', {
          'lg:object-left': alignLogoStart,
        })}
      />
    )}
    {children}
  </div>
)
